import "./freeinstallation.css";
import React, { useState, useEffect } from 'react'
import { Dropdown } from "react-bootstrap";
import { toast } from 'react-toastify';
import Papa from 'papaparse';
import 'react-toastify/dist/ReactToastify.css';
const FreeInstallation = (props) => {
  const [searchvalue, setsearchvalue] = useState("")
  const [warranty, setwarranty] = useState([])
  const [originalWarranty, setoriginalWarranty] = useState([]) // Store original data
  const getFreeInstallation = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetFreeInstallation`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setwarranty(response.data)
          setoriginalWarranty(response.data) // Store original data for reset
        } else {
          toast.error("No Warranty Found")
        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }

  }
  useEffect(() => {
    getFreeInstallation()
  }, [])
  function warrantyDate(value) {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const dt = date.getDate();

    const formattedDay = dt < 10 ? "0" + dt : dt;
    const formattedMonth = month < 10 ? "0" + month : month;

    return `${formattedDay}-${formattedMonth}-${year}`;
  }

  function daysLeftToNextTwoYearsFromDate(startDate) {
    // Convert the start date string to a Date object
    const startDateObj = new Date(startDate);


    // Calculate the end date of the warranty period (2 years from the start date)
    const warrantyEndDate = new Date(startDateObj);
    warrantyEndDate.setFullYear(startDateObj.getFullYear() + 4);

    // Calculate the difference in days
    const daysDifference = Math.ceil((warrantyEndDate - new Date()) / (1000 * 60 * 60 * 24));

    return daysDifference;
  }

  const search = async () => {
    if (searchvalue.length > 0) {
      const filteredData = originalWarranty.filter((item) => {
        return item.phone.toLowerCase().includes(searchvalue.toLowerCase())
      })

      setwarranty(filteredData)
      setCurrentPage(1)
    } else {
      // Reset to original data when search input is empty
      setwarranty(originalWarranty)
      setCurrentPage(1)
    }
  }

  const sort = async (value) => {
    // Work with current filtered data
    let dataToSort = [...warranty];

    if (value === "Earliest") {
      const sortedData = dataToSort.sort((a, b) => new Date(b.date) - new Date(a.date));
      setwarranty([...sortedData])
    } else {
      const sortedData = dataToSort.sort((a, b) => new Date(a.date) - new Date(b.date));
      setwarranty([...sortedData])
    }
  }


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20); // Change as per your requirement

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warranty.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const convertToCSV = (data) => {
    const transformedData = data?.map((item) => ({

      CustomerName: item.name,
      Phone: item.phone,
      Email: item.email,

      FreeInstallationRegistrationDate: warrantyDate(item.createdAt),

    }));

    // Generate CSV from transformed data
    const csv = Papa.unparse(transformedData, {
      header: true, // Include headers in CSV
    });

    return csv;
  };
  const downloadCSV = (csvData, fileName) => {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleExportCSV = () => {
    // Export only the currently filtered/displayed data
    const csvData = convertToCSV(warranty);
    downloadCSV(csvData, 'free_installation.csv');
  };
  
  const refreshData = async () => {
    // Clear search input
    setsearchvalue("");
    // Reset to original data from API
    await getFreeInstallation();
    // Reset page
    setCurrentPage(1);
    toast.success("Data refreshed successfully");
  }
  return (
    <>
      <section className="dashbg-color">

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="admin-filters">

              <div className="search-bar">
                <div className="search-container">
                  <form action="">
                    <input type="text" placeholder="Search by- Phone" name="search" value={searchvalue} onChange={(e) => {
                      setsearchvalue(e.target.value)
                      // Auto-reset when input is cleared
                      if (e.target.value === '') {
                        setwarranty(originalWarranty)
                        setCurrentPage(1)
                      }
                    }} />
                    <button type="button" onClick={() => {
                      search()
                    }}><i className="fa fa-search"></i></button>
                  </form>
                </div>
              </div>



              <div className="filters d-flex">
                <button className="btn filter-pop ml-2" style={{ backgroundColor: "#4CAF50", color: "white" }} onClick={refreshData}>
                  Refresh <i className="fas fa-sync-alt"></i>
                </button>

                <Dropdown className="d-inline mx-2">
                  <Dropdown.Toggle id="dropdown-autoclose-true" className="btn filter-pop" >Sort by <i className="fa-light fa-arrow-up-arrow-down"></i>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => {
                      sort("Earliest")
                    }}>Earliest</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      sort("Oldest")
                    }}>Oldest</Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>
                <button className="btn Export-btn filter-pop" onClick={() => {
                  handleExportCSV();
                  toast.success("CSV downloaded successfully")
                }}>Export CSV <i className='fas fa-file-export'></i></button>

              </div>

            </div>
            <div className="freeStyle">
              <button className={`btn  ${props.showInstallation ? "" : "active"}`} onClick={() => {
                props.setShowInstallation(false)
              }}>
                Free Coupan
              </button>
              <button className={`btn  ${props.showInstallation ?  "active" :""}`} onClick={() => {
                props.setShowInstallation(true)
              }}>Free Installation</button>
            </div>
          </div>

        </div>



        <div className="row justify-content-center">
          <div className="col-lg-12 table-bg">
            <div style={{ backgroundColor: "white" }}>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.No.</th>

                      <th scope="col">Customer Name</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Email</th>
                      <th scope="col">Registration Date </th>
                      <th scope="col">Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? currentItems.map((item, index) => {
                      return (
                        <tr key={index}>
                          <th scope="row">{warranty.length - ((currentPage - 1) * itemsPerPage + index)}</th>

                          <td>{item.name}</td>
                          <td>{item.phone}</td>
                          <td>{item.email}</td>
                          <td>{warrantyDate(item.createdAt)}</td>
                          <td>{item.file !== "" ? <a href={item.file} target="_blank"><img src="assets/downloadbtn.svg" /></a> : ""}</td>
                        </tr>
                      )
                    }) : <tr><td colSpan="11" className="text-center">No Warranty Found</td></tr>
                    }


                  </tbody>
                </table>
              </div>
            </div>

            {currentItems.length > 0 ? (
              <div className="row">
                <div className="col-lg-12 text-center" style={{ position: "relative" }}>
                  <div className="pagination pagi">
                    {/* Previous Button */}
                    {currentPage === 1 ? "" : (
                      <a
                        href="javascript:void(0)"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                      >
                        &laquo;
                      </a>
                    )}

                    {/* Paginated Dots Logic */}
                    {(() => {
                      const totalPages = Math.ceil(warranty.length / itemsPerPage);
                      const currentBatch = Math.floor((currentPage - 1) / 5);
                      const startPage = currentBatch * 5 + 1;
                      const endPage = Math.min(startPage + 4, totalPages);

                      return (
                        <>
                          {startPage > 1 && (
                            <a
                              href="javascript:void(0)"
                              onClick={() => goToPage(startPage - 1)}
                            >
                              ...
                            </a>
                          )}
                          {Array.from({ length: endPage - startPage + 1 }).map((_, index) => {
                            const page = startPage + index;
                            return (
                              <a
                                href="javascript:void(0)"
                                key={page}
                                onClick={() => goToPage(page)}
                                className={currentPage === page ? "active" : ""}
                              >
                                {page}
                              </a>
                            );
                          })}
                          {endPage < totalPages && (
                            <a
                              href="javascript:void(0)"
                              onClick={() => goToPage(endPage + 1)}
                            >
                              ...
                            </a>
                          )}
                        </>
                      );
                    })()}

                    {/* Next Button */}
                    {currentPage === Math.ceil(warranty.length / itemsPerPage) ? "" : (
                      <a
                        href="javascript:void(0)"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(warranty.length / itemsPerPage)}
                      >
                        &raquo;
                      </a>
                    )}
                  </div>
                  <div className="table-no-count">
                    Showing {Math.min(indexOfLastItem, warranty.length)} of {warranty.length} results
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

          </div>
        </div>
      </section>

    </>
  )
}
export default FreeInstallation;